import { Snackbar } from '../../../ui/components/pure/snackbar/snackbar.component';
import { InvokeAccessControlComponent } from '../actions/components/invoke-access-control-modal.component';
import { EnableDisableLockerActionModal } from '../details/actions/enable-or-disable-locker/enable-disable-locker-action.component';
import { LockerDetailsActions } from '../details/actions/locker-details.actions';
import { OpenLockerActionModal } from '../details/actions/open-locker/open-locker-action.component';
import { ReserveContainerActionModal } from '../details/actions/reserve-container/reserve-container-action.component';
import { UnreserveContainerActionModal } from '../details/actions/reserve-container/unreserve-container-action.component';
import { useLockersList } from './hooks/use-lockers-list.hook';
import { EditProjectModulesActionComponent } from '../actions/components/edit-project-modules-action.component';

export function LockersListActionsObserver({
  actions,
  projectID
}: {
  actions: ReturnType<typeof useLockersList>['actions'];
  projectID: string;
}) {
  if (actions.currentAction === null) {
    return null;
  }
  switch (actions.currentAction) {
    case LockerDetailsActions.OPEN_LOCKER:
      if (!actions.payload?.deliveryContainerID) {
        return null;
      }
      return (
        <OpenLockerActionModal
          lockerID={actions.payload.deliveryContainerID}
          projectID={projectID}
          onSuccess={(statusHasChanged: boolean) =>
            actions.setAction(statusHasChanged ? LockerDetailsActions.OPEN_LOCKER_STATUS_CHANGE_SUCCESS : null)
          }
          onAbort={() => actions.setAction(null)}
        />
      );
    case LockerDetailsActions.OPEN_LOCKER_STATUS_CHANGE_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The status has been changed successfully.
        </Snackbar>
      );
    case LockerDetailsActions.ENABLE_DISABLE_LOCKER:
      return (
        <EnableDisableLockerActionModal
          lockerID={actions.payload.deliveryContainerID}
          projectID={projectID}
          onSuccess={() => actions.setAction(LockerDetailsActions.ENABLE_DISABLE_LOCKER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );

    case LockerDetailsActions.ENABLE_DISABLE_LOCKER_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The status has been changed successfully.
        </Snackbar>
      );
    case LockerDetailsActions.UNLOCK_ROOM:
      if (!actions.payload.accessControl) {
        return null;
      }
      return (
        <InvokeAccessControlComponent
          accessControl={actions.payload.accessControl}
          onSuccess={() => actions.setAction(null)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case LockerDetailsActions.EDIT_PROJECT_MODULES:
      if (!actions.payload?.deliveryContainerID) {
        return null;
      }
      return (
        <EditProjectModulesActionComponent
          deliveryContainerID={actions.payload.deliveryContainerID}
          onAbort={() => actions.setAction(null)}
          projectIDs={actions.payload.projectIDs}
          onSuccess={() => actions.setAction(LockerDetailsActions.EDIT_PROJECT_MODULES_SUCCESS)}
        />
      );
    case LockerDetailsActions.EDIT_PROJECT_MODULES_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          Update successful.
        </Snackbar>
      );
    case LockerDetailsActions.RESERVE_CONTAINER:
      if (!actions.payload?.deliveryContainerID) {
        return null;
      }
      return (
        <ReserveContainerActionModal
          deliveryContainerID={actions.payload.deliveryContainerID}
          projectID={projectID}
          onSuccess={() => actions.setAction(LockerDetailsActions.RESERVE_CONTAINER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case LockerDetailsActions.RESERVE_CONTAINER_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The delivery container has been reserved.
        </Snackbar>
      );
    case LockerDetailsActions.UNRESERVE_CONTAINER:
      if (!actions.payload?.deliveryContainerID) {
        return null;
      }
      return (
        <UnreserveContainerActionModal
          deliveryContainerID={actions.payload.deliveryContainerID}
          projectID={projectID}
          onSuccess={() => actions.setAction(LockerDetailsActions.UNRESERVE_CONTAINER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case LockerDetailsActions.UNRESERVE_CONTAINER_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The reservation has been removed.
        </Snackbar>
      );
    default:
      return null;
  }
}
